<!-- Begin Page Content -->
<div class="container-fluid">
  <!-- Page Heading -->

  <!-- DataTales Example -->
  <div>
    <!-- <div class="card-header bg-white py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Plants
      </h1>

      <button type="button" class="btn" style="float: right;"
        [routerLink]="['/component', 'plants', 'addplant']">
        Add Plant
      </button>
    </div> -->
    <div class="card-body">
      <div class="table-responsive">
        <table datatable [dtOptions]="dtoptions" class="table table-bordered" width="100%"
          *ngIf="plants && plants.length > 0">
          <thead>
            <tr>
              <th>Name</th>
            </tr>
          </thead>
          
          <tbody>
            <tr *ngFor="let plant of plants">
              <td>
                
                <a style="color: black" (click)="navigate(plant.Id)">{{ plant.Name }}/ {{plant.Location}}</a>
              </td>
             
            </tr>
          </tbody>
        </table>
        <p *ngIf="!plants || plants.length <= 0">No Plants Found !</p>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</div>